import React from "react";

import Button from "@replo/design-system/components/button/Button";
import twMerge from "@replo/design-system/utils/twMerge";
import { ChevronDown } from "lucide-react";

interface ScrollToBottomIndicatorProps {
  isVisible: boolean;
  onScrollToBottom: () => void;
}

export function ScrollToBottomIndicator({
  isVisible,
  onScrollToBottom,
}: ScrollToBottomIndicatorProps) {
  if (!isVisible) {
    return null;
  }

  return (
    <div className="absolute bottom-4 left-1/2 -translate-x-1/2 animate-in fade-in duration-200">
      <Button
        variant="secondary"
        onClick={onScrollToBottom}
        aria-label="Scroll to bottom"
        hasMinDimensions={false}
        UNSAFE_className={twMerge(
          "group w-6 h-6 min-w-6 min-h-6 rounded-full p-0",
          "shadow-md hover:shadow-lg",
          "hover:-translate-y-1 transition-all duration-200",
        )}
      >
        <ChevronDown
          className={twMerge(
            "w-3 h-3 text-muted-foreground",
            "transition-colors duration-200",
            "group-hover:text-foreground",
          )}
        />
      </Button>
    </div>
  );
}
